import SpotlightLayout from './SpotlightLayout.vue'
import TopStories from './TopStories.vue'
import TellimerBriefing from './TellimerBriefing.vue'
import PreviewAndPublish from './PreviewAndPublish.vue'

export default [
  {
    name: 'spotlightLayout',
    title: 'Spotlight layout',
    component: SpotlightLayout,
    isValid: true
  },
  {
      name: 'topStories',
      title: 'Top stories',
      component: TopStories,
      isValid: true
  },
  {
      name: 'tellimerBriefing',
      title: 'Tellimer briefing',
      component: TellimerBriefing,
      isValid: true

  },
  {
      name: 'previewAndPublish',
      title: 'Preview & Publish',
      component: PreviewAndPublish,
      isValid: true
  },
]
